import { fetchRequest } from "@providers/conect";

const createZonaApi = async ( data ) => {
  try {
    const url = `zonas/create`
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const updateZonaApi = async ( id, data ) => {
  try {
    const url = `zonas/update/${id}`
    const response = await fetchRequest(url, {
      method: "PUT",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const viewZonasApi = async ( data ) => {
  try {
    const url = `zonas/view`
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllZonasApi = async () => {
  try {
    const url = `zonas/all`
    const response = await fetchRequest(url, {
      method: "GET"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteZonaApi = async ( id ) => {
  try {
    const url = `zonas/delete/${id}`
    const response = await fetchRequest(url, {
      method: "DELETE"
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const bulkCreateZonasApi = async ( data ) => {
  try {
    const url = `zonas/bulk-create`
    const response = await fetchRequest(url, {
      method: "POST",
      body: {
        zonas: data
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { 
  createZonaApi, 
  updateZonaApi, 
  viewZonasApi, 
  getAllZonasApi, 
  deleteZonaApi, 
  bulkCreateZonasApi 
};